import React from 'react';
import { StepSelector } from '../../Components/StepSelector/StepSelector';
import styles from './NextStepSelector.module.css';
export var NextStepSelector = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            React.createElement(StepSelector, { text: "Continue to wait", info: "We will continue to load and display decision support when it's available.", active: props.shouldWait, value: true, onClick: props.onYes, testId: 'timeout-wait' }),
            React.createElement(StepSelector, { text: "Continue without decision support", info: "We will display any decision support alert(s) loaded to date.", active: !props.shouldWait, value: false, onClick: props.onNo, testId: 'timeout-continue' }))));
};
